/*
 * Prentun eftir máli — prent án ramma.
 *
 * Skráin:  fer ÓBREYTT upp í körfuna (Shopify geymir hana á cdn.shopify.com, ~20 MB þak
 *          á beiðni, mælt 1.11.2026). Skurðurinn fylgir línunni sem hnit og IceGallery
 *          sker með Magick.NET: engin endurþjöppun, ekkert canvas-þak (iOS ~16,7 MP), og
 *          hægt að endurskera án þess að biðja um skrána aftur.
 * Hnit:    _rammi_skurdur = "x,y,b,h" og _rammi_mynd_px_breidd/_haed í pixlum upprunaskrárinnar,
 *          EFTIR EXIF-snúning (eins og myndin birtist; <img> snýr eftir EXIF).
 * Verð:    rammaverd.ashx með prentefninu einu — ALDREI reiknað hér. Án rammalista
 *          dettur handverkið út hjá IceGallery, svo verðið er prentið eitt.
 */
(function () {
  'use strict';

  const SKRA_MEST = 19 * 1024 * 1024;   // beiðnin öll má ekki fara yfir ~20 MiB (413 hjá Shopify)
  const FORSYN_MEST = 2000;             // langhlið forskoðunarmyndarinnar á skjánum
  // Staðalstærðir [styttri, lengri]; snúið eftir myndinni.
  const STADAL = [[10, 15], [13, 18], [15, 21], [18, 24], [20, 30], [21, 29.7], [24, 30], [30, 40], [30, 45], [40, 50], [40, 60], [50, 70]];

  const kr = n => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const cm = n => String(Math.round(n * 10) / 10).replace('.', ',');
  const MB = n => String(Math.round(n / 1024 / 1024 * 10) / 10).replace('.', ',');

  // Upplausnarmörk koma úr efnisskránni (prentUpplausn) — pöntunarkrókurinn hafnar prenti
  // undir aAbyrgd með SÖMU töflu, svo mörkin mega aðeins standa þar. Taflan fer eftir
  // hornalínu prentsins (fjær skoðað = minni upplausn dugar): [{ hornalinaUppAdCm, dpi }],
  // fyrsta færsla sem hornalínan rúmast í gildir, 0 = þaðan í frá.
  //   dpi >= skarpt: í lagi · >= aAbyrgd: á ábyrgð kaupanda (hak) · annars: lokað.
  // Gamla sniðið (tölur) er lesið sem ein færsla: lagmark = skarpt, aAbyrgd = ábyrgð.
  let MORK = { skarpt: [{ hornalinaUppAdCm: 0, dpi: 200 }], aAbyrgd: [{ hornalinaUppAdCm: 0, dpi: 150 }] };
  function lesaMork(pu) {
    if (!pu) return;
    const tafla = (x, vara) => Array.isArray(x) && x.length ? x : typeof x === 'number' ? [{ hornalinaUppAdCm: 0, dpi: x }] : vara;
    MORK = { skarpt: tafla(pu.skarpt, tafla(pu.lagmark, MORK.skarpt)), aAbyrgd: tafla(pu.aAbyrgd, MORK.aAbyrgd) };
  }
  function upplausnarmork(b, h) {
    const horn = Math.hypot(b, h);
    const fletta = t => (t.find(x => !+x.hornalinaUppAdCm || horn <= +x.hornalinaUppAdCm) || t[t.length - 1]).dpi;
    return { skarpt: fletta(MORK.skarpt), lagmark: fletta(MORK.aAbyrgd) };
  }
  const flokkaDpi = (d, b, h) => { const m = upplausnarmork(b, h); return d >= m.skarpt ? 'god' : d >= m.lagmark ? 'tvisyn' : 'of-lag'; };

  // Mynd í körfu: sömu lyklar og rammahonnudur.js (karfan teiknar með teiknaRamma, listi: null).
  const GEYMSLA = 'rh-forsyn:', GEYMD_MEST = 8;
  function geymaMynd(id, gogn) {
    try {
      const skra = JSON.parse(localStorage.getItem(GEYMSLA) || '[]').filter(x => x !== id);
      skra.push(id);
      while (skra.length > GEYMD_MEST) localStorage.removeItem(GEYMSLA + skra.shift());
      localStorage.setItem(GEYMSLA + id, gogn);
      localStorage.setItem(GEYMSLA, JSON.stringify(skra));
    } catch (e) { /* fullt eða bannað: karfan sýnir þá sýnimyndina */ }
  }

  // "efni: texti" á hverri línu -> [[efni, texti], ...] í röð línanna (hlutur myndi raða tölulyklum).
  const lesaLinur = texti => (texti || '').split('\n')
    .map(lina => lina.match(/^\s*(\d+)\s*:\s*(.+)$/)).filter(Boolean).map(m => [m[1], m[2].trim()]);

  function prentun(rot) {
    const API = rot.dataset.api.replace(/\/$/, '');
    const $ = sel => rot.querySelector(sel);
    const cv = $('[data-rp=skurdur]');

    // Hámark á prentsíðunni [minni, stærri] úr efnisskránni (prentHamark — viðskiptaákvörðun).
    // EKKI prentHamarkMinniKantur: það er það sem prentarinn ræður við. 50 × 70 aðeins til vara.
    let HAMARK = [50, 70];
    let PAPPIR = [];

    // b, h = prentstærð í cm. zoom ≥ 1; (cx, cy) = miðja skurðarins í pixlum upprunans.
    const s = { pappir: null, b: 30, h: 40, skra: null, forsyn: null, pw: 0, ph: 0, zoom: 1, cx: 0, cy: 0, abyrgd: false };

    // ---------------------------------------------------------------------
    // Skurður — stærsti rammi í hlutfalli prentsins sem rúmast í myndinni, deilt með zoom.
    // ---------------------------------------------------------------------
    function skurdur() {
      if (!s.pw) return null;
      const a = s.b / s.h;
      let w = s.pw, h = s.pw / a;
      if (h > s.ph) { h = s.ph; w = s.ph * a; }
      w /= s.zoom; h /= s.zoom;
      s.cx = Math.min(Math.max(s.cx, w / 2), s.pw - w / 2);
      s.cy = Math.min(Math.max(s.cy, h / 2), s.ph - h / 2);
      const x = Math.round(s.cx - w / 2), y = Math.round(s.cy - h / 2);
      return { x, y, w: Math.min(Math.round(w), s.pw - x), h: Math.min(Math.round(h), s.ph - y) };
    }
    // dpi fyrir skurð k á prentstærð b × h. Hlutfallið er það sama, svo minni talan ræður.
    const dpi = (k, b, h) => Math.floor(Math.min(k.w / (b / 2.54), k.h / (h / 2.54)));
    const dpiFlokkur = (d, b = s.b, h = s.h) => flokkaDpi(d, b, h);
    // Mesta dpi sem stærð b × h getur fengið úr myndinni (allur skurðurinn, zoom 1).
    function mestaDpi(b, h) {
      const a = b / h; let w = s.pw, hh = s.pw / a;
      if (hh > s.ph) { hh = s.ph; w = s.ph * a; }
      return dpi({ w, h: hh }, b, h);
    }
    const innanHamarks = (b, h) => Math.min(b, h) <= HAMARK[0] + 1e-9 && Math.max(b, h) <= HAMARK[1] + 1e-9;

    // ---------------------------------------------------------------------
    // Teikning: öll myndin, dekkt utan skurðarins.
    // ---------------------------------------------------------------------
    let kvardi = 1;
    function teikna() {
      if (!s.forsyn) return;
      const svid = cv.closest('.rh__svid');
      const maxW = Math.min(svid.clientWidth - 32, 900), maxH = Math.min(window.innerHeight - 260, 760);
      kvardi = Math.min(maxW / s.pw, Math.max(240, maxH) / s.ph);
      const W = Math.round(s.pw * kvardi), H = Math.round(s.ph * kvardi), dpr = window.devicePixelRatio || 1;
      cv.width = W * dpr; cv.height = H * dpr; cv.style.width = W + 'px'; cv.style.height = H + 'px';
      const ctx = cv.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.drawImage(s.forsyn, 0, 0, W, H);
      const k = skurdur();
      const x = k.x * kvardi, y = k.y * kvardi, w = k.w * kvardi, h = k.h * kvardi;
      ctx.fillStyle = 'rgba(30,28,26,.62)';
      ctx.beginPath(); ctx.rect(0, 0, W, H); ctx.rect(x, y, w, h); ctx.fill('evenodd');
      ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.strokeRect(x + .75, y + .75, w - 1.5, h - 1.5);
      ctx.strokeStyle = 'rgba(255,255,255,.35)'; ctx.lineWidth = 1; ctx.beginPath();
      for (let i = 1; i < 3; i++) { ctx.moveTo(x + w * i / 3, y); ctx.lineTo(x + w * i / 3, y + h); ctx.moveTo(x, y + h * i / 3); ctx.lineTo(x + w, y + h * i / 3); }
      ctx.stroke();
      uppfaera();
    }

    // Dregið: skurðurinn fylgir fingrinum.
    let drag = null;
    cv.addEventListener('pointerdown', e => { if (!s.forsyn) return; drag = { x: e.clientX, y: e.clientY }; cv.setPointerCapture(e.pointerId); });
    cv.addEventListener('pointermove', e => {
      if (!drag) return;
      s.cx += (e.clientX - drag.x) / kvardi; s.cy += (e.clientY - drag.y) / kvardi;
      drag = { x: e.clientX, y: e.clientY }; teikna();
    });
    const sleppa = () => { drag = null; };
    cv.addEventListener('pointerup', sleppa); cv.addEventListener('pointercancel', sleppa);

    // ---------------------------------------------------------------------
    // Skráin
    // ---------------------------------------------------------------------
    function lesaSkra(skra) {
      const info = $('[data-rp=skrainfo]');
      s.skra = null; s.forsyn = null; s.pw = 0;
      if (!skra) return syna();
      if (skra.size > SKRA_MEST) {
        info.textContent = `Skráin er ${MB(skra.size)} MB en mest má senda 19 MB. Vistaðu hana sem JPEG í aðeins lægri gæðum, eða hafðu samband og við tökum við henni öðruvísi.`;
        return syna();
      }
      info.textContent = 'Les myndina…';
      const url = URL.createObjectURL(skra), img = new Image();
      img.onload = () => {
        // naturalWidth/Height eru eftir EXIF-snúning — sama hnitakerfi og IceGallery sker í.
        s.pw = img.naturalWidth; s.ph = img.naturalHeight;
        const k = Math.min(1, FORSYN_MEST / Math.max(s.pw, s.ph));
        const c = document.createElement('canvas'); c.width = Math.round(s.pw * k); c.height = Math.round(s.ph * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        s.skra = skra; s.forsyn = c; s.zoom = 1; s.cx = s.pw / 2; s.cy = s.ph / 2;
        $('[data-rp=adrattur]').value = 1;
        // Prentið fylgir stefnu myndarinnar.
        if ((s.pw > s.ph) !== (s.b > s.h)) [s.b, s.h] = [s.h, s.b];
        info.textContent = `${skra.name} · ${s.pw} × ${s.ph} px · ${MB(skra.size)} MB`;
        syna();
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        info.textContent = 'Vafrinn getur ekki lesið þessa skrá (t.d. TIFF eða HEIC). Vistaðu hana sem JPEG og reyndu aftur.';
        syna();
      };
      img.src = url;
    }

    function syna() {
      const er = !!s.forsyn;
      $('[data-rp=tomt]').hidden = er; cv.hidden = !er;
      $('[data-rp=adgerdir]').hidden = !er; $('[data-rp=hjalp]').hidden = !er;
      if (er) teikna(); else uppfaera();
    }

    // ---------------------------------------------------------------------
    // Verð — sama verðstigaleið og rammahönnuðurinn: ódýrasta afbrigði ≥ verði IceGallery.
    // ---------------------------------------------------------------------
    let STIGI = null;
    fetch(rot.dataset.vara)
      .then(r => r.ok ? r.json() : null)
      .then(v => {
        if (!v) return;
        STIGI = v.variants.filter(x => x.available).map(x => ({ id: x.id, verd: x.price / 100 })).sort((a, b) => a.verd - b.verd);
        if (!STIGI.length) STIGI = null;
        if (STIGI) { $('[data-rp=panta]').hidden = false; sidastaBod = ''; uppfaera(); }
      })
      .catch(() => {});

    let verdTimi = 0, verdNr = 0, sidastaBod = '', tilbod = null;
    function saekjaVerd(bod) {
      const lykill = JSON.stringify(bod);
      const tala = $('[data-rp=verd]'), ath = $('[data-rp=verdath]');
      if (lykill === sidastaBod) return;
      sidastaBod = lykill; tilbod = null; uppfaeraPanta();
      tala.classList.add('rh-gamalt');
      clearTimeout(verdTimi);
      verdTimi = setTimeout(async () => {
        const nr = ++verdNr;
        try {
          const svar = await fetch(API + '/rammaverd.ashx', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: lykill });
          if (nr !== verdNr) return;
          if (svar.status === 429) { sidastaBod = ''; verdTimi = setTimeout(() => saekjaVerd(bod), 1500); return; }
          if (!svar.ok) throw new Error(svar.status);
          const d = await svar.json();
          let verd = d.samtals.samtals, afbrigdi = null;
          if (STIGI) { afbrigdi = STIGI.find(x => x.verd >= verd) || null; if (afbrigdi) verd = afbrigdi.verd; }
          tala.textContent = kr(verd) + ' kr.'; tala.classList.remove('rh-gamalt');
          ath.textContent = 'Með vsk.';
          tilbod = { lykill, afbrigdi, verd }; uppfaeraPanta();
        } catch (e) {
          if (nr !== verdNr) return;
          tala.textContent = '–'; ath.textContent = 'Verð ekki tiltækt í augnablikinu.'; sidastaBod = '';
        }
      }, 300);
    }

    // ---------------------------------------------------------------------
    // Viðmót
    // ---------------------------------------------------------------------
    const merkt = (el, ja) => el.setAttribute('aria-pressed', ja);
    function hnappur(texti, onclick) {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'rh-chip'; b.innerHTML = texti; b.onclick = onclick; return b;
    }

    function uppfaera() {
      const bIn = $('[data-rp=b]'), hIn = $('[data-rp=h]');
      if (document.activeElement !== bIn) bIn.value = s.b;
      if (document.activeElement !== hIn) hIn.value = s.h;
      $('[data-rp=pappirlysing]').textContent = s.pappir ? s.pappir.lysing : '';
      rot.querySelectorAll('[data-rp=pappir] .rh-chip').forEach(el => merkt(el, el.dataset.efni == (s.pappir && s.pappir.efni)));

      // Staðalstærðir: snúið eftir myndinni, með upplausnarpunkti þegar mynd er komin.
      const lang = s.pw ? s.pw > s.ph : s.b > s.h;
      rot.querySelectorAll('[data-rp=stadal] .rh-chip').forEach(el => {
        const [a, b] = el.dataset.st.split('x').map(Number), [bb, hh] = lang ? [b, a] : [a, b];
        merkt(el, (bb === s.b && hh === s.h) || (el.dataset.st === 'hlutfall' && s.pw && Math.abs(s.b / s.h - s.pw / s.ph) < .005));
        if (el.dataset.st === 'hlutfall') return;
        el.querySelector('i').className = s.pw ? 'rp-punktur rp-' + dpiFlokkur(mestaDpi(bb, hh), bb, hh) : 'rp-punktur';
      });

      const innan = innanHamarks(s.b, s.h);
      $('[data-rp=hamarkath]').textContent = innan
        ? `Mest ${cm(HAMARK[0])} × ${cm(HAMARK[1])} cm. Stærra prent: hafðu samband.`
        : `${cm(s.b)} × ${cm(s.h)} cm er stærra en ${cm(HAMARK[0])} × ${cm(HAMARK[1])} cm sem hægt er að panta hér. Hafðu samband og við gerum þér tilboð.`;
      $('[data-rp=hamarkath]').classList.toggle('rp-villa', !innan);

      const el = $('[data-rp=dpi]'), k = skurdur();
      if (!k) { el.className = 'rp__dpi'; el.textContent = 'Veldu mynd til að sjá upplausnina.'; }
      else {
        const d = dpi(k, s.b, s.h), f = dpiFlokkur(d);
        el.className = 'rp__dpi rp-' + f;
        el.innerHTML = `<b>${d} dpi</b> · ` + {
          god: 'Skörp mynd í þessari stærð.',
          tvisyn: `Myndin getur virst óskýr ef staðið er nálægt henni (skörp frá ${upplausnarmork(s.b, s.h).skarpt} dpi í þessari stærð). Veldu minni stærð, skerðu minna af, eða prentaðu á eigin ábyrgð.`,
          'of-lag': `Of lág upplausn fyrir þessa stærð (minnst ${upplausnarmork(s.b, s.h).lagmark} dpi). Veldu minni stærð eða skerðu minna af.`,
        }[f];
      }
      const tvisyn = k && dpiFlokkur(dpi(k, s.b, s.h)) === 'tvisyn';
      $('[data-rp=abyrgdhluti]').hidden = !tvisyn;
      if (!tvisyn) { s.abyrgd = false; $('[data-rp=abyrgd]').checked = false; }

      if (s.pappir && innan) saekjaVerd({ haed: s.h, breidd: s.b, magn: 1, magnpontun: false, afslattur: 0, efni: [s.pappir.efni] });
      else {
        clearTimeout(verdTimi); verdNr++; sidastaBod = ''; tilbod = null;
        $('[data-rp=verd]').textContent = '–'; $('[data-rp=verdath]').textContent = '';
        uppfaeraPanta();
      }
    }

    // Allt eða ekkert: lína sem IceGallery getur ekki prentað er hafnað EFTIR greiðslu.
    function pantaHindrun() {
      if (!STIGI) return 'skoðun';
      if (!s.skra) return 'Veldu mynd til að prenta.';
      if (!innanHamarks(s.b, s.h)) return '';
      const f = dpiFlokkur(dpi(skurdur(), s.b, s.h));
      if (f === 'of-lag') return 'Upplausnin er of lág fyrir þessa stærð.';
      if (f === 'tvisyn' && !s.abyrgd) return 'Hakaðu við að þú prentir á eigin ábyrgð, eða veldu minni stærð.';
      if (!tilbod) return '';
      if (!tilbod.afbrigdi) return 'Þessi stærð er utan vefverðskrár. Hafðu samband og við gerum þér tilboð.';
      return null;
    }
    function uppfaeraPanta() {
      const takki = $('[data-rp=panta]'), ath = $('[data-rp=pantaath]');
      if (takki.getAttribute('aria-busy')) return;
      const h = pantaHindrun();
      takki.disabled = h !== null;
      ath.hidden = !h || h === 'skoðun';
      ath.textContent = h && h !== 'skoðun' ? h : '';
    }

    function setjaIKorfu() {
      if (pantaHindrun() !== null) return;
      const k = skurdur(), bod = JSON.parse(tilbod.lykill), d = dpi(k, s.b, s.h);
      const id = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      const properties = {
        // Fyrir viðskiptavininn
        'Gerð': 'Prent án ramma',
        'Pappír': s.pappir.heiti,
        'Stærð': `${cm(s.b)} × ${cm(s.h)} cm`,
        'Upplausn': `${d} dpi` + (dpiFlokkur(d) === 'tvisyn' ? ' – á ábyrgð kaupanda' : ''),
        'Skrá': s.skra.name,
        // Fyrir IceGallery. Prent án kartons: móða 0, myndastærð = prentstærð.
        _rammi_mynd_haed: String(s.h),
        _rammi_mynd_breidd: String(s.b),
        _rammi_modur: '0',
        _rammi_efni: bod.efni.join(','),
        _rammi_verd: String(tilbod.verd),
        _rammi_skurdur: [k.x, k.y, k.w, k.h].join(','),
        _rammi_mynd_px_breidd: String(s.pw),
        _rammi_mynd_px_haed: String(s.ph),
        // Forsýning í körfu (teiknaRamma án lista): skurðurinn smækkaður, aðeins í þessum vafra.
        _forsyn: JSON.stringify({ mb: s.b, mh: s.h, moda: 0, strigi: false, listi: null, karton: null, id }),
      };
      const f = s.forsyn.width / s.pw, sk = f * Math.min(1, 900 / (Math.max(k.w, k.h) * f));
      const smatt = document.createElement('canvas');
      smatt.width = Math.max(1, Math.round(k.w * sk)); smatt.height = Math.max(1, Math.round(k.h * sk));
      smatt.getContext('2d').drawImage(s.forsyn, k.x * f, k.y * f, k.w * f, k.h * f, 0, 0, smatt.width, smatt.height);
      try { geymaMynd(id, smatt.toDataURL('image/jpeg', .85)); } catch (e) { /* karfan sýnir þá sýnimynd */ }

      const fd = new FormData();
      fd.append('id', tilbod.afbrigdi.id); fd.append('quantity', '1');
      Object.entries(properties).forEach(([n, v]) => fd.append(`properties[${n}]`, v));
      fd.append('properties[_rammi_prentskra]', s.skra, s.skra.name);

      // XHR en ekki fetch: framvinda upphleðslunnar sést (allt að 19 MB í síma).
      const takki = $('[data-rp=panta]'), stika = $('[data-rp=framvinda]'), ath = $('[data-rp=pantaath]');
      takki.disabled = true; takki.setAttribute('aria-busy', 'true'); takki.textContent = 'Sendi mynd…';
      stika.hidden = false; stika.firstElementChild.style.width = '0';
      const xhr = new XMLHttpRequest();
      xhr.open('POST', rot.dataset.karfaAdd);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.upload.onprogress = e => { if (e.lengthComputable) stika.firstElementChild.style.width = (100 * e.loaded / e.total) + '%'; };
      const mistokst = texti => {
        takki.removeAttribute('aria-busy'); takki.textContent = 'Setja í körfu'; stika.hidden = true; uppfaeraPanta();
        ath.hidden = false; ath.textContent = texti;
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) { window.location.href = rot.dataset.karfa; return; }
        mistokst(xhr.status === 413 ? 'Skráin er of stór til að senda. Vistaðu hana í lægri gæðum eða hafðu samband.' : 'Tókst ekki að setja í körfu. Reyndu aftur.');
      };
      xhr.onerror = () => mistokst('Sambandið rofnaði á meðan myndin var send. Reyndu aftur.');
      xhr.send(fd);
    }

    function byggja() {
      const pBox = $('[data-rp=pappir]');
      PAPPIR.forEach(p => { const b = hnappur(p.heiti, () => { s.pappir = p; uppfaera(); }); b.dataset.efni = p.efni; pBox.appendChild(b); });
      s.pappir = PAPPIR[0] || null;

      const stBox = $('[data-rp=stadal]');
      STADAL.filter(([a, b]) => innanHamarks(a, b)).forEach(([a, b]) => {
        const el = hnappur(`<i class="rp-punktur"></i>${cm(a)} × ${cm(b)}`, () => {
          const lang = s.pw ? s.pw > s.ph : s.b > s.h;
          [s.b, s.h] = lang ? [b, a] : [a, b]; teiknaEdaUppfaera();
        });
        el.dataset.st = a + 'x' + b; stBox.appendChild(el);
      });
      // Óskorin mynd: hlutfall myndarinnar, stærsta stærð innan hámarks sem heldur breiddinni.
      const hl = hnappur('Öll myndin', () => {
        if (!s.pw) return;
        const a = s.pw / s.ph; let b = s.b, h = Math.round(b / a * 10) / 10;
        if (!innanHamarks(b, h)) { const k = Math.min(HAMARK[0] / Math.min(b, h), HAMARK[1] / Math.max(b, h)); b = Math.floor(b * k * 10) / 10; h = Math.round(b / a * 10) / 10; }
        s.b = b; s.h = h; s.zoom = 1; $('[data-rp=adrattur]').value = 1; teiknaEdaUppfaera();
      });
      hl.dataset.st = 'hlutfall'; stBox.appendChild(hl);

      const lesa = () => {
        const b = +String($('[data-rp=b]').value).replace(',', '.'), h = +String($('[data-rp=h]').value).replace(',', '.');
        if (b >= 5 && h >= 5) { s.b = b; s.h = h; teiknaEdaUppfaera(); }
      };
      $('[data-rp=b]').addEventListener('input', lesa); $('[data-rp=h]').addEventListener('input', lesa);
      $('[data-rp=skra]').addEventListener('change', e => lesaSkra(e.target.files[0]));
      $('[data-rp=adrattur]').addEventListener('input', e => { s.zoom = +e.target.value; teikna(); });
      $('[data-rp=snua]').addEventListener('click', () => { [s.b, s.h] = [s.h, s.b]; teiknaEdaUppfaera(); });
      $('[data-rp=midja]').addEventListener('click', () => { s.cx = s.pw / 2; s.cy = s.ph / 2; teikna(); });
      $('[data-rp=abyrgd]').addEventListener('change', e => { s.abyrgd = e.target.checked; uppfaeraPanta(); });
      $('[data-rp=panta]').addEventListener('click', setjaIKorfu);
      let rt = 0; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => s.forsyn && teikna(), 150); });
      uppfaera();
    }
    const teiknaEdaUppfaera = () => (s.forsyn ? teikna() : uppfaera());

    const saekjaSkra = (tilraun = 0) => fetch(API + '/efnisskra.ashx')
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(e => tilraun < 2 ? new Promise(res => setTimeout(res, 800 * (tilraun + 1))).then(() => saekjaSkra(tilraun + 1)) : Promise.reject(e));
    saekjaSkra()
      .then(d => {
        // Heiti og lýsing pappírsins úr þemastillingum; röð stillinganna ræður röðinni (fyrsti sjálfgefinn).
        lesaMork(d.prentUpplausn);
        if (d.prentHamark && d.prentHamark.minniKantur && d.prentHamark.staerriKantur) {
          HAMARK = [+d.prentHamark.minniKantur, +d.prentHamark.staerriKantur].sort((a, b) => a - b);
        }
        const heitiLinur = lesaLinur(rot.dataset.pappirHeiti), rod = heitiLinur.map(([e]) => e);
        const heiti = Object.fromEntries(heitiLinur), lysingar = Object.fromEntries(lesaLinur(rot.dataset.pappirLysingar));
        PAPPIR = (d.prent || []).map(p => ({ efni: p.efni, heiti: heiti[p.efni] || p.heiti, lysing: lysingar[p.efni] || '' }))
          .sort((a, b) => ((rod.indexOf(String(a.efni)) + 1) || 99) - ((rod.indexOf(String(b.efni)) + 1) || 99));
        if (!PAPPIR.length) throw new Error('enginn pappír');
        rot.classList.remove('rh-hledur');
        byggja();
      })
      .catch(() => { rot.classList.remove('rh-hledur'); rot.classList.add('rh-villa'); });
  }

  document.querySelectorAll('[data-prentun]').forEach(prentun);
})();
